"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FormSection = ({ divider = true, uid, title, children, }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [title && ((0, jsx_runtime_1.jsx)("h5", { className: "pad-y-20", id: uid ?? '', children: title })), children, divider && (0, jsx_runtime_1.jsx)("hr", { className: "mar-t-40" })] }));
};
exports.default = FormSection;
